import React from 'react';
import MicrosoftExcelSelect, {
  MicrosoftExcelSelectProps,
} from './MicrosoftExcelSelect';

const PullMicrosoftExcelData: React.FC<MicrosoftExcelSelectProps> = props => (
  <MicrosoftExcelSelect {...props} showRangeFilter />
);

export default PullMicrosoftExcelData;
